import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import Hideable from './_hideable.js'
import PageHeader from './_page-header.js'
import QuickNavigationButton from './_quick-navigation-button.js'
import QuickNavigationPane from './_quick-navigation-pane.js'
import QuickEventsNavigation from './_quick-events-navigation.js'
import EventMarkets from './_event-markets.js'
import EventVisualisationSkeleton from './_event-visualisation-skeleton.js'
import EmptyContent from './_empty-content.js'

export default {
  name: 'EventPage',
  values: {
    visualisationSkeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          hidden: {
            display: 'block',
            position: 'absolute',
            opacity: 0,
          },
        },
      },
    },
    secondaryContentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    pageHeader: {
      configSet: Hideable,
      configValues: {},
    },
    pageHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_padding: '0 0 40px 0',
        },
      },
    },
    pageHeaderConfig: {
      configSet: PageHeader,
      configValues: {
        _mobile_sticky: true,
      },
    },
    documentHeadMetaFactory: undefined,
    quickNavigationButton: {
      configSet: QuickNavigationButton,
      configValues: {},
    },
    quickNavigationPane: {
      configSet: QuickNavigationPane,
      configValues: {},
    },
    quickEventsNavigation: {
      configSet: QuickEventsNavigation,
      configValues: {},
    },
    eventMarkets: {
      configSet: EventMarkets,
      configValues: {},
    },
    eventContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    visualisationContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
        },
      },
    },
    visualisationSkeleton: {
      configSet: EventVisualisationSkeleton,
      configValues: {},
    },
    emptyContent: {
      configSet: EmptyContent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
